export default __webpack_public_path__ + "static/media/mycareplanmanager-logo.86a18a09.png";